const baseUrl = 'http://payment-dev.shiplogic.nl';

export const environment = {
  production: false,
  test: false,
  demo: false,
  dev: true,
  local: false,
  application: {
    baseUrl,
    name: 'Payment',
    logoUrl: ''
  },
  apis: {
    default: {
      url: 'https://api-dev.shiplogic.nl',
      rootNamespace: 'SF.ShipLogic.Payment'
    }
  }
};
